import { isStaffMcpPlaygroundRuntime } from "@/features/mcp-playground/access";

export function canAccessAgentChatLogs(hasGlobalAdminRole: boolean): boolean {
  return isStaffMcpPlaygroundRuntime() && hasGlobalAdminRole;
}
